import { merge } from 'Shared/common/merge';

export function standardPoster(palette,fonts)
{
	return ({
		/* NOTE a venue's own settings file merges its overrides into this */
		shared: {
			root: {
				color: palette.text,
				fontFamily: fonts.text,
				lineHeight: 1.2,
				width: 300,//was 264,
				height: 375,// was 373.296 AS 'calc(264px * 1.414)',
				textAlign: 'center',
				fontSize: 16
			},
			dateBar: { },
			name: {
				fontSize: 16,
				textTransform: 'uppercase',

			},

			tagline: {
				/* A venue can give this a fluid CSS length rather than a plain pixel count */
				fontSize: 16 as number|string,
			},
			artistNames: {
				fontSize: 16
			},

//TODO nest in 'type:' or something... or raise these up a level? Remove 'Poster'
			fiveActs: {
				name: {
					fontSize: 13
				},
			},
		}
	});
}

//XXX Q: do we really want to access these via 'page'?

export function posterSettings(siteTheme)
{
	return siteTheme.page.poster.shared;
}

/* The shared settings with one of the poster types ('fiveActs') laid over. */
export function posterTypeSettings(siteTheme,posterType:string)
{
	const shared = siteTheme.page.poster.shared;

	return merge(shared,shared[posterType] ?? {});
}

